// Shared validation constants for form schemas.

// Phone: optional leading +, must start and end with a digit, parentheses
// only around digit groups (e.g. area code), allows spaces/hyphens/dots
// between groups, 7–20 chars total, at least 3 digits.
export const PHONE_REGEX =
  /^(?=.{7,20}$)(?=(?:\D*\d){3,})\+?\(?\d[\d\s\-().]*\d$/;
export const PHONE_ERROR_MESSAGE = "Please enter a valid phone number";
